import { cancel, fork, take } from 'redux-saga/effects';

interface ICancellableSagaFactoryOptions {
  START_SAGA_ACTION: string;
  CANCEL_SAGA_ACTION: string;

  cancellableTask: () => IterableIterator<any>;
}

export const createCancellableSaga = ({
  START_SAGA_ACTION,
  CANCEL_SAGA_ACTION,
  cancellableTask,
}: ICancellableSagaFactoryOptions): (() => IterableIterator<any>) => {
  return function* main() {
    while (yield take(START_SAGA_ACTION)) {
      const task: any = yield fork(cancellableTask);

      yield take(CANCEL_SAGA_ACTION);
      yield cancel(task);
    }
  };
};



// WEBPACK FOOTER //
// ./src/helpers/sagas.ts